// extracted by mini-css-extract-plugin
export var container = "_dg-0";
export var fill = "_dg-2";
export var track = "_dg-1";